import Vue from 'vue'
import Vuex from 'vuex'
import api from './api'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        uniqueKey: '',
        isLoggedIn: false,
        isPublic: false,
        chatOpened: false,
        isLoading: false,
        isAdmin: false,
        fairConfig: {},
        routerHistory: [],
        webRTC: false,
        permissions: null,
        publicPermissions: null,
        rol_id: null,
        currentTagDropDown: null,
        trackingEvents: [],
        FOOTER_URL_PREFIX: 'https://',
        email:''
    },
    mutations: {
        SET_TRACKING_EVENTS(state, payload) {
            if (payload == null) {
                state.trackingEvents = []
                return
            }
            state.trackingEvents.push(payload)
        },
        SET_CURRENT_DROPDOWN_ID(state, payload) {
            state.currentTagDropDown = payload
        },
        SET_ROL_ID(state, payload) {
            state.rol_id = payload
        },
        SET_LOADING(state, bool) {
            state.isLoading = bool;
        },
        CHANGE_CHAT_OPENED: (state, value = !state.chatOpened) => {
            state.chatOpened = value
        },
        CHANGE_ORIENTATION: (state, value) => {
            state.orientation = value
        },
        CHANGE_IS_LOGGED: (state, value) => {
            state.isLoggedIn = value
        },
        CHANGE_IS_PUBLIC: (state, value) => {
            state.isPublic = value
        },
        CHANGE_IS_ADMIN: (state, value) => {
            localStorage.setItem('isAdmin', value);
            state.isAdmin = value
        },
        CHANGE_EMAIL: (state, value) => {
            state.email = value
        },
        CHANGE_FAIRCONFIG: (state, newObj) => {
            state.fairConfig = newObj
        },
        SET_UNIQUEKEY: (state, key) => {
            state.uniqueKey = key
        },
        CHANGE_FAIRCONFIG_KEY: (state, {
            key,
            value
        }) => {
            this.$set(state.fairConfig, key, value);
        },
        ADD_HISTORY(state, path) {
            if (state.routerHistory.length > 50) state.routerHistory.shift();
            state.routerHistory.push(path);
        },
        POP_HISTORY(state) {
            state.routerHistory.pop();
            state.routerHistory.pop();
        },
        CHANGE_WEB_RTC: (state, payload) => {
            state.webRTC = payload
        },
        SET_PERMISSIONS: (state, payload) => {
            state.permissions = payload;
        },
        SET_PUBLIC_PERMISSIONS: (state, payload) => {
            state.publicPermissions = payload;
        }
    },
    getters: {
        trackingEvents: state => {
            return state.trackingEvents
        },
        globalLoading: state => {
            return state.isLoading;
        },
        getKey: state => {
            return state.uniqueKey;
        },
        isChatOpen: state => {
            return state.chatOpened
        },
        globalFairConfig: state => {
            return state.fairConfig
        },
        isLoggedIn: state => {
            return state.isLoggedIn;
        },
        isPublic: state => {
            return state.isPublic;
        },
        isAdmin: state => {
            return state.isAdmin;
        },
        routerHistory: state => {
            return state.routerHistory
        },
        webRTC: state => {
            return state.webRTC
        },
        permissions: state => state.permissions,
        publicPermissions: state => state.publicPermissions,
    },
    actions: {
        setTrackingEvents({ commit }, payload) {
            commit("SET_TRACKING_EVENTS", payload)
        },
        setCurrentTagDropDownId(store, payload) {
            store.commit("SET_CURRENT_DROPDOWN_ID", payload)
        },
        setRolId(store, payload) {
            store.commit("SET_ROL_ID", payload)
        },
        updateFairConfig(store, obj) {
            store.commit('CHANGE_FAIRCONFIG', obj);
        },
        saveHistoryNavigation(state, path) {
            state.commit('ADD_HISTORY', path);
        },
        setLoading(store, bool) {
            store.commit("SET_LOADING", bool);
        },
        setLoggedIn(store, bool) {
            store.commit("CHANGE_IS_LOGGED", bool)
        },
        setIsAdmin(store, bool) {
            store.commit("CHANGE_IS_ADMIN", bool)
        },
        setIsPublic(store, bool) {
            store.commit("CHANGE_IS_PUBLIC", bool)
        },
        login(store, params) {
            return api.login(params)
        },
        setChat(store, bool) {
            if (bool & !store.state.isLoggedIn) {
                if (parseInt(store.state.fairConfig.FC_LOGREG)) {
                    router.push('/login');
                }
                return;
            }
            store.commit('CHANGE_CHAT_OPENED', bool);
        },
        saveUniqueKey(store, key) {
            store.commit('SET_UNIQUEKEY', key);
        },
        popHistoryTwice(store) {
            store.commit('POP_HISTORY');
        },
        changeWebRTC(store, payload) {
            store.commit('CHANGE_WEB_RTC', payload)
        },
        setPermissions(store, payload) {
            store.commit('SET_PERMISSIONS', payload)
        },
        setPublicPermissions(store, payload) {
            store.commit('SET_PUBLIC_PERMISSIONS', payload)
        }
    }
})